import { useProcess } from '@react-query/hooks/query/use-process';
import type { ReactNode } from 'react';
import { GetProcessError } from './get-process-error';
import { ProcessNotFoundError } from './process-not-found-error';

interface ProcessErrorBoundaryProps {
    children: ReactNode;
}

const PROCESS_NOT_FOUND_STATUS = 404;

export const ProcessErrorBoundary = ({ children }: ProcessErrorBoundaryProps) => {
    const { error } = useProcess();

    if (error) {
        if (error.status === PROCESS_NOT_FOUND_STATUS) {
            return <ProcessNotFoundError />;
        }

        return <GetProcessError />;
    }

    return children;
};
